import(/* webpackMode: "eager" */ "/home/runner/work/kadima-digital/kadima-digital/src/app/error.tsx");
